/**
 * @generated SignedSource<<8b6174806e3273ec17a26273d0870119>>
 * @relayHash 1cf2c68f8894ef74a759ab4fca4f0ec1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7424e0a7af234d3ba1a603f35b349be6af05ca53135b67e93abbc690fb04a466

import type { ConcreteRequest, Query } from 'relay-runtime';
export type InsightsRecommendationVisibility = "HIDDEN" | "REMOVED" | "SNOOZED" | "VISIBLE" | "%future added value";
export type footer_NBTgithubOnboardingDetails_Query$variables = {
  cloudId: string;
  projectAri?: string | null | undefined;
};
export type footer_NBTgithubOnboardingDetails_Query$data = {
  readonly insights: {
    readonly githubOnboardingDetails: {
      readonly outboundAuthUrl: string;
      readonly recommendationVisibility: InsightsRecommendationVisibility;
    };
  } | null | undefined;
};
export type footer_NBTgithubOnboardingDetails_Query = {
  response: footer_NBTgithubOnboardingDetails_Query$data;
  variables: footer_NBTgithubOnboardingDetails_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "concreteType": "Insights",
    "kind": "LinkedField",
    "name": "insights",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectAri",
            "variableName": "projectAri"
          }
        ],
        "concreteType": "InsightsGithubOnboardingDetails",
        "kind": "LinkedField",
        "name": "githubOnboardingDetails",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "recommendationVisibility"
          },
          {
            "kind": "ScalarField",
            "name": "outboundAuthUrl"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "footer_NBTgithubOnboardingDetails_Query",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "footer_NBTgithubOnboardingDetails_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7424e0a7af234d3ba1a603f35b349be6af05ca53135b67e93abbc690fb04a466",
    "metadata": {},
    "name": "footer_NBTgithubOnboardingDetails_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f35e63616c932bb39cf8b019606404e9";

export default node;
